import React, { useState, useRef } from "react";
import { withRedux } from "helpers";
import WebIcon from "./WebIcon";
import styled, { css } from "react-emotion";
import LoginSignup from "../Authentication/LoginSignup";
import { useScrollPosition } from "./useScrollPosition";

const DropDown = styled("div")`
  position: fixed;
  z-index: 2;
  right: 4em;
  background: white;
  padding: 10px;
  width: 215px;
  visibility: ${(props) => (props.show ? "visible" : "hidden")};
  transition: all 100ms ${(props) => (props.show ? "ease-in" : "ease-out")};
  transform: ${(props) => (props.show ? "none" : "translate(0, -100%)")};
`;

const option = css`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  color: #1f3747;
  /* background: rgba(30,30,30,1); */
  transition: 0.1s;

  &:hover {
    /* background: rgba(40,40,40,1); */
    background: #c8c8c9;
    transition: 0.2s;
  }
`;

const spanStyle = css`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.25px;
  display: inline-block;
  text-align: center;
`;

function WebProfile(props) {
  const [showDropDown, setShowDropDown] = useState(false);

  const toggleDropdown = () => setShowDropDown(!showDropDown);
  const { view } = props.activeApp;
  const { user } = props.platformInfo.status;
  let isAnonymousUser = false;
  if (user) {
    isAnonymousUser = user.tempUser === 1;
  }

  const logOut = () => {
    props.actions.logOut();
    toggleDropdown();
    props.actions.webFeatureLogin(props.activeApp.id, null);
  };

  // console.log("********************************");
  // console.log("USER INFO");
  // console.log("********************************");
  // console.log("isAnonymousUser : " + isAnonymousUser);

  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== showDropDown) setShowDropDown(false);
    },
    [showDropDown]
  );

  // console.log(showDropDown);
  return (
    <div>
      <div onClick={toggleDropdown}>
        <WebIcon
          iconName={"user"}
          stroke={view.navigation.navBarColor}
          strokeWidth={"2px"}
          strokeLinejoin={"round"}
          size={"20px"}
          useColor={false}
          hover={true}
        />
      </div>
      {showDropDown && (
        <DropDown show={showDropDown}>
          {user ? (
            <p className={spanStyle} color={view.navigation.navBarColor}>
              Welcome back, {user.firstName ? user.firstName : "Guest"}!
            </p>
          ) : (
            <p className={spanStyle} color={view.navigation.navBarColor}>
              Welcome back, Guest!
            </p>
          )}
          {!isAnonymousUser && user ? (
            <div className={option} onClick={logOut}>
              Log Out
            </div>
          ) : null}
          {(isAnonymousUser || !user) && (
            // <div
            //   className={option}
            //   onClick={() => {
            //     console.log("log in/sign up clicked clicked");
            //   }}
            // >
            //   Log in or Sign Up
            // </div>
            <div style={{ color: view.navigation.navBarColor }}>
              <LoginSignup
                split={true}
                isWeb={true}
                callback={toggleDropdown}
                customColor={true}
              />
            </div>
          )}
        </DropDown>
      )}
    </div>
  );
}

export default withRedux(WebProfile);

// ) : (
//
// )
